<!--https://github.com/angular/components/issues/4580#issuecomment-1423197872-->
<mat-form-field [subscriptSizing]="data.subscriptSizing ?? 'fixed'">
  @if (data.label) {
    <mat-label>{{ data.label }}</mat-label>
  }
  
  <input
    [control]="control"
    [data]="data"
    [formControl]="control"
    [matDatepicker]="picker"
    [matDatepickerFilter]="data.filter ?? defaultFilter()"
    matInput
    uiFormInputAttributes
    uiFormInputValidators
  />

  <mat-datepicker #picker></mat-datepicker>

  <mat-datepicker-toggle [for]="picker" matSuffix (click)="onDatePickerToggleClicked()">
    <ui-icon faName="calendar-days" faStyle="light" matDatepickerToggleIcon></ui-icon>
  </mat-datepicker-toggle>

  <mat-error [control]="control" [data]="data" uiFormError></mat-error>

  @if (data.hint) {
    <mat-hint [innerHtml]="data.hint" align="start"></mat-hint>
  }

  @if (data.additionalHint) {
    <mat-hint align="end">
      <span>{{ data.additionalHint }}</span>
    </mat-hint>
  }
</mat-form-field>

@if (data.description) {
  <ui-form-input-description [description]="data.description"></ui-form-input-description>
}
